import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface ConfirmationDialogProps {
  title: string;
  message: string;
  positiveText?: string;
  positiveAction: () => void;
  negativeText?: string;
  negativeAction: () => void;
  open: boolean;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { t } = useTranslation('common');

  const {
    title,
    message,
    positiveText,
    positiveAction,
    negativeText,
    negativeAction,
    open,
    ...other
  } = props;

  const yes = positiveText ? positiveText : t('common.yes');
  const no = positiveText ? positiveText : t('common.no');

  return (
    <Dialog disableEscapeKeyDown maxWidth="xs" open={open} {...other}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={positiveAction}
          autoFocus>
          {yes}
        </Button>
        <Button variant="contained" color="secondary" onClick={negativeAction}>
          {no}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
